module.exports = __webpack_public_path__ + "img/cc-discover.b10f5ddd.png";